(function () {
  if (!document.body.classList.contains('template-collection')) return;

  var container = document.querySelector('.t4s-section-main [data-ntajax-container]');
  if (!container) return;

  var options = {};
  try {
    options = JSON.parse(container.getAttribute('data-ntajax-options') || '{}');
  } catch (e) {
    return;
  }

  var sectionId = options.id;
  var loading = false;
  var scrollObserver = null;
  var observedWrap = null;

  function getGrid() {
    return (
      container.querySelector('[data-contentlm-replace].rb-product-cards') ||
      container.querySelector('[data-contentlm-replace]')
    );
  }

  function getLoadMoreBtn() {
    return container.querySelector('[data-wrap-lm] [data-load-more]:not([data-is-prev])');
  }

  function getLoadMoreWrap() {
    return container.querySelector('[data-wrap-lm]');
  }

  function stripThemeInfiniteScroll() {
    container.querySelectorAll('[data-load-onscroll]').forEach(function (el) {
      el.removeAttribute('data-load-onscroll');
      el.classList.remove('t4s-lm-onscroll-init');
    });
  }

  function updateLoadMoreFromResponse(doc) {
    var newWrap = doc.querySelector('[data-wrap-lm]');
    var wrap = getLoadMoreWrap();
    if (!wrap) return;

    if (newWrap && newWrap.querySelector('[data-load-more]')) {
      wrap.innerHTML = newWrap.innerHTML;
      wrap.hidden = false;
      wrap.style.display = '';
    } else {
      wrap.innerHTML = '';
      wrap.hidden = true;
      if (scrollObserver && observedWrap) {
        scrollObserver.unobserve(observedWrap);
        observedWrap = null;
      }
    }
  }

  function hidePaginationControls() {
    container.querySelectorAll('[data-wrap-lm], [data-wrap-lm-prev]').forEach(function (wrap) {
      wrap.style.cssText =
        'border:0!important;margin:0!important;padding:0!important;min-height:64px;height:64px;overflow:hidden;';
    });

    container.querySelectorAll('[data-load-more], [data-load-onscroll]').forEach(function (btn) {
      btn.removeAttribute('data-load-onscroll');
      btn.style.cssText =
        'opacity:0!important;pointer-events:none!important;border:0!important;background:transparent!important;height:64px;min-height:64px;margin:0;padding:0;overflow:hidden;';
      btn.querySelectorAll('.t4s-btn-atc_text, .t4s-btn-icon').forEach(function (el) {
        el.style.display = 'none';
      });
    });
  }

  function ensureFirstPageUrl() {
    var url = new URL(window.location.href);
    if (!url.searchParams.has('page')) return false;

    url.searchParams.delete('page');
    window.location.replace(url.pathname + url.search + url.hash);
    return true;
  }

  function lazyInitYotpo() {
    if (!window.yotpo || typeof window.yotpo.initWidgets !== 'function') return;

    var pending = document.querySelectorAll(
      '.rb-product-cards .yotpo.bottomLine:not(.rb-yotpo-ready)'
    );
    if (!pending.length) return;

    if (!('IntersectionObserver' in window)) {
      pending.forEach(function (el) {
        el.classList.add('rb-yotpo-ready');
      });
      window.yotpo.initWidgets();
      if (typeof window.rbCleanupYotpoBadges === 'function') {
        window.rbCleanupYotpoBadges();
      }
      return;
    }

    var yotpoObserver = new IntersectionObserver(
      function (entries, obs) {
        var needsInit = false;
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('rb-yotpo-ready');
          obs.unobserve(entry.target);
          needsInit = true;
        });
        if (needsInit) {
          window.yotpo.initWidgets();
          if (typeof window.rbCleanupYotpoBadges === 'function') {
            window.rbCleanupYotpoBadges();
          }
        }
      },
      { rootMargin: '120px 0px', threshold: 0.01 }
    );

    pending.forEach(function (el) {
      yotpoObserver.observe(el);
    });
  }

  function loadNextPage() {
    var btn = getLoadMoreBtn();
    var wrap = getLoadMoreWrap();
    if (!btn || !wrap || wrap.hidden || loading) return;

    var href = btn.getAttribute('href');
    if (!href) {
      wrap.hidden = true;
      return;
    }

    loading = true;
    btn.classList.add('is--loading');

    var fetchUrl = href + (href.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + sectionId;

    fetch(fetchUrl, {
      method: 'GET',
      headers: { 'Cache-Control': 'no-cache' },
    })
      .then(function (res) {
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('[data-contentlm-replace]');
        var grid = getGrid();

        if (newGrid && grid) {
          grid.insertAdjacentHTML('beforeend', newGrid.innerHTML);
        }

        updateLoadMoreFromResponse(doc);

        if (window.T4SThemeSP && typeof window.T4SThemeSP.reinitProductGridItem === 'function') {
          window.T4SThemeSP.reinitProductGridItem();
        }

        lazyInitYotpo();
        if (typeof window.rbHydrateProductStars === 'function') {
          window.rbHydrateProductStars();
        }
        if (typeof window.rbSyncCollectionCardHighlight === 'function') {
          window.rbSyncCollectionCardHighlight();
        }
      })
      .catch(function () {})
      .finally(function () {
        loading = false;
        var currentBtn = getLoadMoreBtn();
        if (currentBtn) currentBtn.classList.remove('is--loading');

        var nextBtn = getLoadMoreBtn();
        var nextWrap = getLoadMoreWrap();
        if (nextBtn && nextWrap && !nextWrap.hidden) {
          var rect = nextWrap.getBoundingClientRect();
          if (rect.top < window.innerHeight + 800) {
            loadNextPage();
          }
        }
      });
  }

  function bindInfiniteScroll() {
    stripThemeInfiniteScroll();

    if (!('IntersectionObserver' in window)) return;

    var wrap = getLoadMoreWrap();
    if (!wrap || wrap.hidden || !getLoadMoreBtn()) {
      if (scrollObserver && observedWrap) {
        scrollObserver.unobserve(observedWrap);
        observedWrap = null;
      }
      return;
    }

    if (observedWrap === wrap && scrollObserver) return;

    if (scrollObserver) {
      scrollObserver.disconnect();
    }

    scrollObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !loading) loadNextPage();
        });
      },
      { rootMargin: '800px 0px', threshold: 0 }
    );

    scrollObserver.observe(wrap);
    observedWrap = wrap;
  }

  function initCollectionPage() {
    if (ensureFirstPageUrl()) return;

    hidePaginationControls();
    bindInfiniteScroll();
    lazyInitYotpo();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionPage);
  } else {
    initCollectionPage();
  }

  window.addEventListener('load', initCollectionPage);
  document.addEventListener('shopify:section:load', initCollectionPage);
})();
